import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_V1_URL } from '../config/api.config';
import './VerifyCertificatePage.css';

const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : '';

const VerifyCertificatePage = () => {
  const { certId } = useParams();
  const navigate = useNavigate();
  const [cert, setCert] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const load = async () => {
      try {
        const res = await axios.get(`${API_V1_URL}/certificates/verify/${certId}`);
        setCert(res.data);
      } catch (e) {
        if (e.response?.status === 404) {
          setError('Certificate not found. The certificate ID may be invalid or revoked.');
        } else {
          setError('Unable to verify certificate. Please try again later.');
        }
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [certId]);

  if (loading) {
    return (
      <div className="vc-page">
        <div className="vc-card">
          <div className="vc-loading">Verifying certificate…</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="vc-page">
        <div className="vc-card">
          <div className="vc-icon vc-icon-invalid">✕</div>
          <h1 className="vc-title vc-title-invalid">Certificate Not Verified</h1>
          <p className="vc-subtitle">{error}</p>
          <button className="vc-btn" onClick={() => navigate('/')}>
            Go to Homepage
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="vc-page">
      <div className="vc-card">
        <div className="vc-icon vc-icon-valid">✓</div>
        <h1 className="vc-title vc-title-valid">Certificate Verified</h1>
        <p className="vc-subtitle">
          This certificate is valid and was issued by Batos IT Solutions.
        </p>

        <div className="vc-details">
          <div className="vc-row">
            <span className="vc-label">Certificate ID</span>
            <span className="vc-value vc-mono">{cert.certificate_id}</span>
          </div>
          <div className="vc-row">
            <span className="vc-label">Issued To</span>
            <span className="vc-value">{cert.user_name}</span>
          </div>
          <div className="vc-row">
            <span className="vc-label">Project</span>
            <span className="vc-value">{cert.project_title}</span>
          </div>
          {cert.college_name && (
            <div className="vc-row">
              <span className="vc-label">College</span>
              <span className="vc-value">{cert.college_name}</span>
            </div>
          )}
          {cert.course_name && (
            <div className="vc-row">
              <span className="vc-label">Course</span>
              <span className="vc-value">{cert.course_name}</span>
            </div>
          )}
          <div className="vc-row">
            <span className="vc-label">Issued On</span>
            <span className="vc-value">{fmtDate(cert.issued_at)}</span>
          </div>
        </div>

        <div className="vc-footer">
          <img
            src="/final_logo.png"
            alt="Batos IT Solutions"
            className="vc-logo"
          />
          <p className="vc-org">BATOS IT SOLUTIONS</p>
          <p className="vc-legal">
            This verification confirms that the certificate was officially issued by
            Batos IT Solutions LLP, Pune.
          </p>
        </div>

        <button className="vc-btn" onClick={() => navigate('/')}>
          Go to Homepage
        </button>
      </div>
    </div>
  );
};

export default VerifyCertificatePage;
